module.exports = __webpack_public_path__ + "img/icon_medal_select.382fb645.png";